module.exports = __webpack_public_path__ + "static/media/mini_darth.ebf452a5.png";